import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { DesignTool } from '../../../../../viewer/tools/design-tool';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { useDesignTool } from '../hooks/use-design-tool';
import { ToolIcon } from '../tool-icon';

const DesignToolIcon = () => {
  const { t } = useTranslation();
  const { activeTool } = React.useContext(SkyviewContext);
  const { isEnabled } = useDesignTool();

  const onClick = () => {
    InputHandler.instance.setTool('design');
  };

  return (
    <>
      <ToolIcon
        active={activeTool instanceof DesignTool}
        callback={onClick}
        disabled={!isEnabled}
        icon={['fal', 'pen-ruler']}
        tooltip={{
          title: t('design.tooltip.title', { ns: 'skyviewToolbar' }),
          text: isEnabled ? (
            t('design.tooltip.text', { ns: 'skyviewToolbar' })
          ) : (
            <Trans
              components={{ br: <br /> }}
              i18nKey="design.tooltip.textDisabled"
              ns="skyviewToolbar"
            />
          ),
        }}
      />
    </>
  );
};

export { DesignToolIcon };
